import { Dialog, DialogContent } from '@mui/material';
import React from 'react';

import { AddonCrown32C } from '@/assets';
import { UIDialogTitle } from '@/shared/components';
import { useMedia } from '@/shared/hooks';

import { BsimmTab } from './components';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const AdminPanel: React.FC<Props> = ({
  isOpen,
  onClose,
}) => {
  const { isSmallScreen } = useMedia();
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullScreen={isSmallScreen}
      fullWidth
      maxWidth='lg'
      scroll='paper'
      aria-labelledby='dialog-title'
      aria-describedby='dialog-content'
    >
      <UIDialogTitle
        id='dialog-title'
        title={'Admin Panel'}
        startIcon={
        <AddonCrown32C style={{
          width: '1.25rem',
          height: '1.25rem'
        }} />
      }
        onCloseBtnAction={handleClose}
      />

      <DialogContent id='dialog-content'>
        <BsimmTab />
      </DialogContent>
    </Dialog>
  );
};

export default AdminPanel;